<template>
  <div :class="`product-bundle-gallery__item product-bundle-gallery__item--${productType?.toLowerCase()}`">
    <img
      :src="image"
      :width="width"
    >
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useBundleStore } from '../pinia/BundleStore'

import { getSizedImageUrl } from '@shopify/theme-images'

export default {
  props: {
    product: {
      type: Object,
      default: null
    },
    productType: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState (useBundleStore, [
      'isDuo',
      'isTrio'
    ]),

    width () {
      if (this.isDuo) {
        return 357
      } else if (this.isTrio) {
        return 238
      } else if (this.productType === 'Sachet') {
        return 250
      } else if (this.productType === 'Shaker') {
        return 177
      }
      return 400
    },
    imageDimensions () {
      return `${this.width * 2}x`
    },
    image () {
      // console.error(this.product)
      let image = null
      if (this.product?.image) {
        image = this.product.image
      }
      if (this.product.images?.length > 0) {
        if (this.product.images?.[0]?.includes('.jpg') && this.product.images?.[1]?.includes('.png')) {
          image = this.product.images[1]
        } else {
          image = this.product.images?.[0]
        }
      }
      return image ? getSizedImageUrl(image, this.imageDimensions) : null
    }
  },
}
</script>
